module.exports = __webpack_public_path__ + "img/352.d6bbfb1e.png";